import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import LinkButtonExample from '../examples/LinkButton';
import LinkButtonUnderlineExample from '../examples/LinkButtonUnderline';
const LinkButtonExampleSource = require('!!raw-loader!../examples/LinkButton');
const LinkButtonUnderlineExampleSource = require('!!raw-loader!../examples/LinkButtonUnderline');
export default class LinkButtonPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Link"/>
                <h3>Link</h3>
                <div className="docs-example">
                    <LinkButtonExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{LinkButtonExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>Link Button Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`
type Props = {|
  tag: string,
  color: ?ColorListType,
  onClick: Function,
  href: ?string,
  children: Node,
  tabIndex: number,
  className: string,
  underline: boolean,
|};

LinkButton.defaultProps = {
  tabIndex: 0,
  color: null,
  href: null,
  className: '',
  underline: false,
  tag: 'button',
};
`}
                        </PrismCode>
                    </pre>
                </div>
                <h3>Link underline color</h3>
                <div className="docs-example">
                    <LinkButtonUnderlineExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{LinkButtonUnderlineExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
